export interface AttributionState {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_term: string;
  utm_content: string;
  ms?: string;
  mwsc?: string;
  referrer: string;
}

// Action Types
const SET_ATTRIBUTION_PARAMS = 'SET_ATTRIBUTION_PARAMS';

// Initial State
const INITIAL_STATE: AttributionState = {
  utm_source: '',
  utm_medium: '',
  utm_campaign: '',
  utm_term: '',
  utm_content: '',
  ms: '',
  mwsc: '',
  referrer: '',
};

// Actions
export const setAttributionParams = (payload: Partial<AttributionState>) => ({
  type: SET_ATTRIBUTION_PARAMS,
  payload,
});

// Reducer
export default function attributionReducer(
  state = INITIAL_STATE,
  action: { type: string; payload?: Partial<AttributionState> }
): AttributionState {
  switch (action.type) {
    case SET_ATTRIBUTION_PARAMS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
